<script>
    
    import Project from '../components/Project.svelte';
	import { onMount } from 'svelte';

    let projects = [
        {
            title: "TrackTheRecovery.org",
            img: "econ-tracker.png",
            url: "https://www.tracktherecovery.org/",
            text: "A series of economic indicators made available with more granularity and speed than traditional economic data allow viewers to see the impact of the pandemic and how the recovery is progressing. ",
        },
        {
            title: "Breathing City",
            img: "breathing-city.gif",
            url: "https://www.darkhorseanalytics.com/blog/breathing-city",
            text: "An experiment to simulate work and home populations in New York city on a typical day combining data sets from four different sources.",
        },
        {
            title: "Opportunity Atlas",
            img: "opp-atlas.png",
            url: "https://www.opportunityatlas.org/",
            text: "Which neighborhoods in America offer children the best chance at a better life than their parents? The Opportunity Atlas maps millions of data points to facilitate creating local solutions that help more children rise out of poverty.",
        },
        {
            title: "Alberta Well Water Quality",
            img: "aephin.png",
            url: "http://aephin.alberta.ca/water/water-map.htm",
            text: "An exploratory tool for analysts to view well water testing results and investigate their correlations, distributions, and geographic patterns.",
        },
        {
            title: "Data Looks Better Naked",
            img: "data-naked.png",
            url: "https://www.darkhorseanalytics.com/remove-to-improve",
            text: "A series of animated gifs outlining guidelines for making your visuals more effective and attractive.",
        },
        {
            title: "Surgo Precision for COVID",
            img: "surgo.png",
            url: "https://www.precisionforcoviddata.org/",
            text: "Explore a wide range of data to understand vulnerability and how to better plan, prepare, and respond to COVID-19.",
        },

    ]

    onMount(() => {
        window.scrollTo(0, 0);
    });
   
</script>

  

<div class="container">
    
    <h2><img src="./images/joey.png" alt="Joey Cherdarchuk"/>Hi, <br>my name is Joey Cherdarchuk&nbsp;&amp;<br> I'm a data visualization designer.</h2>
    <div class="callout">I specialize in understanding your goals and your data to help you communicate with, connect to, and spur change in your audiences.</div>       

    <h3>About</h3>
        <p>After co-founding Darkhorse Analytics and leading its data visualization practice, I recently stepped away to work as a freelance designer. I’ve been doing analysis my whole career and visualization for the past decade. I'm passionate about creating tools that are both clear and engaging. I’m on the lookout for interesting work. You can reach me at 
        <a href="mailto:joeycherdarchuk@gmail.com">joeycherdarchuk@gmail.com</a>.
    </p>

    <h3>Select Projects</h3>
    {#each projects as {title, img, url, text}}
        <Project {title} {img} {url} {text}/>
    {/each}

    <div class="spacer" style="height: 20vh;"></div>

    <div class="pageNav">
        <div class="links">
            <a href="/">Back</a> &nbsp;&nbsp;&nbsp;&nbsp;| &nbsp;&nbsp;&nbsp;&nbsp;<a href="/credits">Credits</a>
            <div style="display:inline; float:right; "><a href="mailto:joeycherdarchuk@gmail.com" style="text-transform:lowercase; font-family:'Titillium Web', sans-serif">joeycherdarchuk@gmail.com</a></div>
        </div>
    </div>
   
</div>






<style>

    .container {
	  max-width: 900px;
	  margin: 0 auto;
      padding: 40px;
    }

    .callout {
        font-size: 32px;
        line-height: 140%;
        font-weight: 200;
        margin-top: 30px
    }

    h2 {
        font-size: 36px;
        line-height: 50px;
        max-width: 900px;
        width: 100%;
    }

    h2 img {
        width:130px; 
        float:right;
    }

    @media screen and (max-width: 900px) {
        h2 img {
            width:130px; 
            float: none;
            display: block;
            margin-bottom: 20px;
        }
    }

    h3 {
        font-family: 'Poppins', 'Arial Black', sans-serif;
        margin-top: 2em;
        margin-bottom: 0;
        text-transform: uppercase;
        letter-spacing: 0.05em;
        font-size: 16px;
        font-weight: 800;
        height: auto;
        color: #9CBCE0;
    }

    p {
        margin: 8px 0 1em 0;
        font-size: 16px;
    }

    a {
        color: #9CBCE0;
    }

    .pageNav {
        position: fixed;
        bottom: 0;
        left: 0;
        font-size: 12px;
        font-family: 'Poppins', 'Century Gothic', sans-serif;
        background-color: #1B1F22;
        width: 100%;
        padding: 15px 0;
        /* border-top: solid 1px #222; */
    }

    .pageNav a {
        color: #9CBCE0;
        text-transform: uppercase;
    }



    .pageNav a:hover {
        text-decoration: none;
        border-bottom: 1px dashed #9CBCE0;
    }

    .links {
	  max-width: 900px;
	  margin: 0 auto;
      padding: 0 40px;
    }
</style>